import { useState, useEffect } from 'react';

const useFetch = url => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const fetchData = async () => {
      const res = await fetch(url);
      const dataObject = await res.json();
      setData(dataObject);
      setLoading(false);
    };
    if (url) {
      fetchData().catch(err => console.error(err));
      setLoading(true);
    }
  }, [url]);
  return { data, loading };
};

export default useFetch;
